import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * HTTP Interceptor that adds credentials to all HTTP requests.
 * This ensures that cookies, authorization headers, and other credentials
 * are included with cross-origin requests.
 */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request and set withCredentials to true
    const credentialReq = req.clone({
      setHeaders: {
        // You can add any additional headers here if needed
      },
      // This is the key setting that includes credentials with the request
      withCredentials: true
    });

    return next.handle(credentialReq);
  }
}
